import { render, staticRenderFns } from "./QuestionTemplateCreateAndEditDialog.vue?vue&type=template&id=17e2eafa&scoped=true"
import script from "./QuestionTemplateCreateAndEditDialog.vue?vue&type=script&lang=js"
export * from "./QuestionTemplateCreateAndEditDialog.vue?vue&type=script&lang=js"
import style0 from "./QuestionTemplateCreateAndEditDialog.vue?vue&type=style&index=0&id=17e2eafa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e2eafa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSwitch,VTooltip})
